import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { formatStat } from "../../../helper/statsFormatter";
import { StyledCurrency } from "../../../helper/StyledCurrency";
import { NETWORK_ICON_MAP } from "../../../utils/networkConstants";
import CommonLoader from "../../../common_components/CommonLoader";
import MobileClientDetailModal from "./MobileClientDetailModal";
const ClientPerformanceMobileCards = ({ data, loading, globalDateRange, }) => {
    const [modalRow, setModalRow] = useState(null);
    const [differenceModes, setDifferenceModes] = useState({});
    const toggleDifferenceMode = (rowId) => {
        setDifferenceModes((prev) => ({ ...prev, [rowId]: !prev[rowId] }));
    };
    const renderIcon = (row) => {
        if (row.id === "all_clients")
            return null;
        const normalize = (str) => (str || "").toLowerCase().trim();
        // ✅ Priority: Shopify > GA > Paid (Meta + Adword + Bing)
        let hasShopifyIcon = false;
        let hasGaIcon = false;
        let hasMetaIcon = false;
        let hasGoogleIcon = false;
        let hasBingIcon = false;
        const channelList = row.channel || [];
        channelList.forEach((channel) => {
            const mc = normalize(channel);
            if (mc.includes('shopify'))
                hasShopifyIcon = true;
            if (mc.includes('ga') || mc.includes('analytics'))
                hasGaIcon = true;
            if (mc.includes('meta') || mc.includes('facebook'))
                hasMetaIcon = true;
            if (mc.includes('adword') || mc.includes('google'))
                hasGoogleIcon = true;
            if (mc.includes('bing'))
                hasBingIcon = true;
        });
        if (hasShopifyIcon) {
            hasGaIcon = hasMetaIcon = hasGoogleIcon = hasBingIcon = false;
        }
        else if (hasGaIcon) {
            hasMetaIcon = hasGoogleIcon = hasBingIcon = false;
        }
        return (_jsxs(Box, { sx: { display: "flex", alignItems: "center" }, children: [hasShopifyIcon && (_jsx("img", { src: NETWORK_ICON_MAP.shopify, style: {
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        backgroundColor: "#ECFDF3",
                        padding: 2,
                    } })), hasGaIcon && (_jsx("img", { src: NETWORK_ICON_MAP.ga, style: {
                        width: 24,
                        height: 24,
                        alignSelf: "center",
                    } })), hasGoogleIcon && (_jsx("img", { src: NETWORK_ICON_MAP.adword, style: {
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        backgroundColor: "#EEF4FF",
                        padding: 5,
                    } })), hasMetaIcon && (_jsx("img", { src: NETWORK_ICON_MAP.meta, style: {
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        backgroundColor: "#ecfbfdff",
                        padding: 5,
                        position: "relative",
                        left: hasGoogleIcon ? -10 : 0,
                    } })), hasBingIcon && (_jsx("img", { src: NETWORK_ICON_MAP.bing, style: {
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        backgroundColor: "#FEF3F2",
                        padding: 5,
                        position: "relative",
                        left: (hasGoogleIcon || hasMetaIcon) ? -10 : 0,
                    } }))] }));
    };
    if (loading) {
        return (_jsx(Box, { sx: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }, children: _jsx(CommonLoader, { className: "table-loader" }) }));
    }
    if (!data || data.length === 0)
        return null;
    return (_jsxs(Box, { sx: { display: "flex", flexDirection: "column", gap: 1, p: 1 }, children: [data.map((row) => {
                const rowId = row._id || row.id;
                const revenue = row.overall_stats?.total_revenue || 0;
                const diffPercent = row.differenceChange || 0;
                const diffValue = row.differenceValue || 0;
                const isDiffPositive = diffPercent >= 0;
                const isValueMode = differenceModes[rowId];
                const projected = Number(row.projectedRevenue ?? 0);
                const variance = Number(row.projectedVariance ?? 0);
                const isVarPositive = variance >= 0;
                const roundedVar = Math.round(Math.abs(variance));
                return (_jsxs(Box, { sx: {
                        border: "1.5px solid #E5E7EB",
                        borderRadius: "8px",
                        overflow: "hidden",
                        bgcolor: "#fff",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                    }, children: [_jsxs(Box, { sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                px: 2,
                                py: 1.5,
                                borderBottom: "1px solid #F1F5F9",
                            }, children: [renderIcon(row), _jsx(Typography, { sx: {
                                        fontWeight: 600,
                                        fontSize: "15px",
                                        flex: 1,
                                        color: "#0f172a",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }, children: row.name === "All Clients" ? "All Client" : row.name }), _jsx(Box, { component: "img", src: "/assets/chartmob.svg", sx: {
                                        width: 16,
                                        height: 16,
                                        cursor: "pointer",
                                        flexShrink: 0,
                                    }, onClick: () => setModalRow(row) })] }), _jsxs(Box, { sx: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                px: 2,
                                py: 1,
                                backgroundColor: "#F4F4F5",
                            }, children: [_jsx(Typography, { sx: { fontSize: "12px", color: "#64748b", fontWeight: 500 }, children: "Revenue(%)" }), _jsx(Typography, { sx: {
                                        fontSize: "12px",
                                        color: "#64748b",
                                        fontWeight: 500,
                                        textAlign: "right",
                                    }, children: "Difference" })] }), _jsxs(Box, { sx: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                alignItems: "center",
                            }, children: [_jsxs(Box, { sx: {
                                        px: 1,
                                        py: 1.5,
                                    }, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }, children: [_jsx(Typography, { sx: { fontSize: "14px", fontWeight: 700, color: "#0f172a" }, children: _jsx(StyledCurrency, { className: "valueclassclient", value: formatStat(revenue, "revenue") }) }), _jsxs(Box, { sx: {
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "2px",
                                                        px: 1,
                                                        py: "2px",
                                                        borderRadius: "9999px",
                                                        bgcolor: isVarPositive ? "#dcfce7" : "#fee2e2",
                                                        color: isVarPositive ? "#16a34a" : "#dc2626",
                                                        fontSize: "11px",
                                                        fontWeight: 500,
                                                    }, children: [roundedVar, "%", isVarPositive ? (_jsx(TrendingUpIcon, { sx: { fontSize: 12 } })) : (_jsx(TrendingDownIcon, { sx: { fontSize: 12 } }))] })] }), _jsx(Typography, { sx: { fontSize: "12px", color: "#94a3b8", mt: 0.25 }, children: _jsx(StyledCurrency, { className: "valueclass2", value: formatStat(projected, "revenue") }) })] }), _jsx(Box, { sx: {
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        bgcolor: isDiffPositive ? "#ECFDF3" : "#FEF3F2",
                                        px: 1,
                                        py: 0,
                                        minHeight: "100%",
                                    }, children: _jsxs(Box, { onClick: (e) => {
                                            e.stopPropagation();
                                            toggleDifferenceMode(rowId);
                                        }, sx: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 0.5,
                                            px: 1.5,
                                            py: "5px",
                                            borderRadius: "9999px",
                                            bgcolor: isDiffPositive ? "#dcfce7" : "#fee2e2",
                                            color: isDiffPositive ? "#16a34a" : "#dc2626",
                                            fontSize: "13px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            userSelect: "none",
                                            transition: "all 0.2s",
                                            minWidth: "70px",
                                            justifyContent: "center",
                                        }, children: [isValueMode ? (_jsx(StyledCurrency, { symbolColor: isDiffPositive ? "#16a34a" : "#dc2626", className: "valueclassclient2", value: formatStat(diffValue, "revenue") })) : (`${Math.round(Math.abs(diffPercent))}%`), isDiffPositive ? (_jsx(TrendingUpIcon, { sx: { fontSize: 14 } })) : (_jsx(TrendingDownIcon, { sx: { fontSize: 14 } }))] }) })] })] }, rowId));
            }), _jsx(MobileClientDetailModal, { open: !!modalRow, onClose: () => setModalRow(null), row: modalRow, globalDateRange: globalDateRange })] }));
};
export default ClientPerformanceMobileCards;
